import React from 'react';
import ContactSection from './ContactSection';
import './ContactPage.css';

const ContactPage: React.FC = () => {
  return (
    <div className="contact-page">
      <ContactSection />
    </div>
  );
};

export default ContactPage;
